import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CurrentUser } from '@shared/interfaces';
import { UserRoleEnum } from '@shared/enums';
import { UserApi } from '@core/api';


@Injectable({ providedIn: 'root' })
export class CurrentUserService {
    currentUser$: Subject<CurrentUser> = new Subject<CurrentUser>();
    currentUserError$: Subject<boolean> = new Subject<boolean>();

    isUnauthorized$: Subject<boolean> = new Subject<boolean>();

    initialUserDetailsPromise?: Promise<CurrentUser>;

    private currentUser: CurrentUser = {
        id: -1,
        firstName: '',
        lastName: '',
        shortName: '',
        longName:'',
        email: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        city: '',
        stateOrProvinceCode: '',
        postalCode: '',
        organization: '',
        roles: [],
        phoneNumber: '',
        countryCode: ''
    };

    constructor(private userApi: UserApi) {}

    async initializeCurrentUser(): Promise<CurrentUser> {
        if (this.initialUserDetailsPromise) {
            return this.initialUserDetailsPromise;
        }

        return new Promise<CurrentUser>(async resolve => {
            if (this.currentUser.id > 0) {
                resolve(this.currentUser);
            }
            this.initialUserDetailsPromise = this.userApi.getCurrentUserDetails();
            const response = await this.initialUserDetailsPromise;
            if (response) {
                this.setCurrentUser(response);
                resolve(response);
            }
        });
    }

    getCurrentUser(): CurrentUser {
        return this.currentUser;
    }

    getCurrentUserRoles(): UserRoleEnum[] {
        return this.currentUser.roles || [];
    }

    setCurrentUser(user: CurrentUser): void {
        this.currentUser$.next(user);
        this.currentUser = user;
    }

    triggerUserDetailsError(hasError: boolean): void {
        this.currentUserError$.next(hasError);
    }

    triggerUnauthorizedError(value: boolean): void {
        this.isUnauthorized$.next(value);
    }

    emptyUser() : CurrentUser{
        return {
            id: -1,
            firstName: '',
            lastName:'',
            shortName : '',
            longName : '',
            addressLine1: '',
            addressLine2:'',
            addressLine3: '',
            city: '',
            stateOrProvinceCode: '',
            postalCode: '',
            email: '',
            organization: '',
            roles: [],
            phoneNumber: '',
            countryCode: '',
        }
    }
}
